import { render, staticRenderFns } from "./Method.vue?vue&type=template&id=cadf2654&scoped=true&"
import script from "./Method.vue?vue&type=script&lang=js&"
export * from "./Method.vue?vue&type=script&lang=js&"
import style0 from "./Method.vue?vue&type=style&index=0&id=cadf2654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadf2654",
  null
  
)

export default component.exports